function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Outline_Old_Icons",
  "data-name": "Outline Old Icons"
}, React.createElement("path", {
  d: "M11.3,23a11.13,11.13,0,0,1-7.89-3.23A11.6,11.6,0,0,1,0,11.7,11.3,11.3,0,0,1,3.33,3.51,11.72,11.72,0,0,1,11.49,0a11.19,11.19,0,0,1,8.1,3.23A11.57,11.57,0,0,1,11.51,23Zm.4-22h-.19A10.73,10.73,0,0,0,4,4.21a10.29,10.29,0,0,0-3,7.47,10.61,10.61,0,0,0,3.11,7.38A10.26,10.26,0,0,0,11.49,22a10.57,10.57,0,0,0,7.4-18.06A10.16,10.16,0,0,0,11.7,1Zm-.2,16a.5.5,0,0,1-.5-.5V11a.5.5,0,0,1,1,0v5.5A.5.5,0,0,1,11.5,17Zm-.89-9.5a.89.89,0,0,1,.89-.89h0a.89.89,0,0,1,.89.89h0a.88.88,0,0,1-.89.88h0a.88.88,0,0,1-.89-.88Z"
})));

var SvgInfo = function SvgInfo(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 23 23",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgInfo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/info.c2e73efc.svg";
export { ForwardRef as ReactComponent };